var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{staticClass:"p-3",attrs:{"theme":"opacity","shape":"radius","bg-color":"#dcdbdc"}},_vm._l((_vm.itemsCount),function(i){return _c('tb-skeleton',{key:i,staticClass:"mt-2",attrs:{"aspect-ratio":_vm.height}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642a9077","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeletons/sk-list.vue
// module id = 494
// module chunks = 40